export const GENERIC_API_ERROR_MESSAGE =
  "Ocorreu um erro inesperado. Tente novamente. Se o problema persistir, entre em contato com a empresa desenvolvedora.";

const normalizeErrorValue = (value) => {
  if (value === null || value === undefined) return "";
  if (typeof value === "string") return value.trim();
  if (typeof value === "object") {
    return String(value.message || value.msg || "").trim();
  }
  return String(value).trim();
};

const normalizeErrorCollection = (value) => {
  if (Array.isArray(value)) {
    return value.map(normalizeErrorValue).filter(Boolean);
  }

  if (value && typeof value === "object") {
    return Object.values(value)
      .flatMap((item) => (Array.isArray(item) ? item : [item]))
      .map(normalizeErrorValue)
      .filter(Boolean);
  }

  return [];
};

export const getApiErrorMessage = (error) => {
  const responseData = error?.response?.data;
  const message = normalizeErrorValue(responseData?.message);

  if (message) return message;

  const messages = normalizeErrorCollection(responseData?.message);
  if (messages.length) return messages.join("<br/>");

  const validationErrors = normalizeErrorCollection(responseData?.errors);
  if (validationErrors.length) return validationErrors.join("<br/>");

  const responseText = normalizeErrorValue(responseData);
  if (responseText) return responseText;

  return GENERIC_API_ERROR_MESSAGE;
};
